const sanitizeString = string =>
  string.replace(new RegExp(/[<>/;()]/, 'ig'), '').trim();

export default sanitizeString;
